import { __read, __spread } from "tslib";
export function flatten(arr) {
    var result = [];
    arr.forEach(function (item) {
        if (Array.isArray(item)) {
            result = __spread(result, flatten(item));
        }
        else {
            result.push(item);
        }
    });
    return result;
}
//# sourceMappingURL=flatten.js.map